import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login-show-app-version',
  templateUrl: './login-show-app-version.component.html',
  styleUrls: ['./login-show-app-version.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginShowAppVersionComponent implements OnInit {
  public appVersion: string;

  constructor() { }

  ngOnInit() {
    this.appVersion = environment.appVersion.toString();
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/login-show-app-version/login-show-app-version.component.ts